import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

document.documentElement.style.scrollBehavior = 'smooth';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Register service worker for PWA (offline support + installability)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// ── iOS Safari PWA install banner ──────────────────────────────────────────
// Safari doesn't fire beforeinstallprompt — we show a manual guide instead.
// Only shows on iPhone/iPad Safari, not already-installed, not dismissed.
(function mountIOSBanner() {
  const isIOS        = /iPhone|iPad|iPod/.test(navigator.userAgent);
  const isSafari     = /Safari/.test(navigator.userAgent) && !/CriOS|FxiOS|OPiOS|mercury/.test(navigator.userAgent);
  const isStandalone = window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
  if (!isIOS || !isSafari || isStandalone) return;
  if (localStorage.getItem('ios_install_dismissed') === '1') return;

  const el = document.createElement('div');
  el.id = 'ios-install-banner';
  document.body.appendChild(el);

  function Banner() {
    const [visible, setVisible] = React.useState(true);
    if (!visible) return null;
    const dismiss = () => { localStorage.setItem('ios_install_dismissed','1'); setVisible(false); document.getElementById('ios-install-banner')?.remove(); };
    const G = '#1a6b3c';
    return (
      React.createElement('div', { style:{position:'fixed',bottom:0,left:0,right:0,zIndex:99999,background:'linear-gradient(135deg,#0d3d1f,'+G+')',color:'white',padding:'14px 18px 22px',boxShadow:'0 -4px 28px rgba(0,0,0,.4)',fontFamily:'system-ui,-apple-system,sans-serif'} },
        React.createElement('div', { style:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:12,marginBottom:12} },
          React.createElement('div', { style:{display:'flex',gap:12,alignItems:'center'} },
            React.createElement('img', { src:'/logo192.png', alt:'', style:{width:46,height:46,borderRadius:11,border:'2px solid rgba(255,255,255,.3)',flexShrink:0} }),
            React.createElement('div', null,
              React.createElement('div', { style:{fontWeight:800,fontSize:15,marginBottom:2} }, 'Install QK Academy'),
              React.createElement('div', { style:{fontSize:12,opacity:.85,lineHeight:1.5} }, 'Add to your Home Screen for the full app experience.')
            )
          ),
          React.createElement('button', { onClick:dismiss, style:{background:'rgba(255,255,255,.2)',border:'none',borderRadius:7,padding:'5px 9px',color:'white',fontSize:16,cursor:'pointer',lineHeight:1,flexShrink:0} }, '✕')
        ),
        React.createElement('div', { style:{display:'flex',flexDirection:'column',gap:7} },
          [['1','Tap the  Share  button at the bottom of Safari','□↑'],
           ['2','Scroll down and tap  "Add to Home Screen"','⊞'],
           ['3','Tap  "Add"  in the top-right corner','✓']
          ].map(function(item) {
            return React.createElement('div', { key:item[0], style:{display:'flex',alignItems:'center',gap:10,background:'rgba(255,255,255,.12)',borderRadius:9,padding:'9px 12px'} },
              React.createElement('div', { style:{background:'rgba(255,255,255,.25)',borderRadius:'50%',width:24,height:24,display:'flex',alignItems:'center',justifyContent:'center',fontWeight:900,fontSize:12,flexShrink:0} }, item[0]),
              React.createElement('div', { style:{fontSize:12,flex:1,lineHeight:1.45} }, item[1]),
              React.createElement('div', { style:{fontSize:18,opacity:.65,flexShrink:0} }, item[2])
            );
          })
        ),
        React.createElement('button', { onClick:dismiss, style:{marginTop:12,width:'100%',background:'rgba(255,255,255,.18)',border:'1px solid rgba(255,255,255,.3)',borderRadius:9,padding:'9px',color:'white',fontWeight:700,fontSize:13,cursor:'pointer'} }, 'Got it — remind me later')
      )
    );
  }

  ReactDOM.createRoot(el).render(React.createElement(React.StrictMode, null, React.createElement(Banner)));
})();
